export * from './public_api';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /Users/makebetter/Documents/sportsceneDash/~/angularfire2/database/index.js
// module id = ../../../../angularfire2/database/index.js
// module chunks = 4